import { useGetTextMessagesQuery } from "api/apiSlice";
import { TextMessage } from "./textMessage";

export const TextMessagesList = () => {
  const {
    data: textMessages = [],
    isLoading,
    isSuccess,
    isError,
    error,
  } = useGetTextMessagesQuery(null, {
    pollingInterval: 10000,
  });

  let textMessagesContent;
  if (isSuccess || isLoading) {
    if (textMessages.length > 0) {
      textMessagesContent = textMessages.map((tm) => (
        <TextMessage key={tm.messageId} message={tm} />
      ));
    } else {
      textMessagesContent = (
        <p className="p-4 text-center">There are no questions!</p>
      );
    }
  } else if (isError) {
    if ("data" in error)
      textMessagesContent = (
        <p className="text-center my-4">
          Oh no! A wild {error.status} error appeared!
        </p>
      );
  }

  return <div>{textMessagesContent}</div>;
};
